export const validatePlate = (placa) => {
    if (placa.length < 7) return false;

    const regex = '[A-Z]{3}[0-9][0-9A-Z][0-9]{2}';
    return placa.match(regex);
}

const checkIfIsTouched = (errors, formTouched) => {
    if (errors?.placa && !formTouched?.placa) {
        delete errors.placa
        errors.isFormValid = false
    }
    if (errors?.confirmPlaca && !formTouched?.confirmPlaca) {
        delete errors.confirmPlaca
        errors.isFormValid = false
    }
    if (errors?.categoriaVeiculo && !formTouched?.categoriaVeiculo) {
        delete errors.categoriaVeiculo
        errors.isFormValid = false
    }
    if (errors?.categoriaEixo && !formTouched?.categoriaEixo) {
        delete errors.categoriaEixo
        errors.isFormValid = false
    }

    return errors;
}

const validateIfNotEmpty = (form, errors, formTouched) => {
    if (!form?.placa) errors.placa = "Placa é obrigatória"
    if (!form?.confirmPlaca) errors.confirmPlaca = "A confirmação da placa é obrigatória"
    if (!form?.categoriaVeiculo) errors.categoriaVeiculo = "Categoria é obrigatório"
    if (!form?.categoriaEixo) errors.categoriaEixo = "Categoria de eixo é obrigatório"

    return errors;
}

const validateIfNotInvalid = (form, errors, formTouched) => {
    if (!errors?.placa && formTouched?.placa && !validatePlate(form?.placa)) errors.placa = "Placa inválida"
    if (!errors?.confirmPlaca && formTouched?.confirmPlaca && !validatePlate(form?.confirmPlaca)) errors.confirmPlaca = "confirmação da placa inválida"

    return errors;
}

const checkIfEquals = (form, errors, formTouched) => {
    if (
        (errors?.placa && errors?.confirmPlaca) &&
        (formTouched?.placa && formTouched?.confirmPlaca)
    ) return errors

    if (form?.placa !== form?.confirmPlaca) errors.confirmPlaca = "As placas não coincidem"

    return errors;
}

export const ValidateForm = (form, formTouched) => {
    const errors = {
        isFormValid: true
    }

    validateIfNotEmpty(form, errors, formTouched)
    validateIfNotInvalid(form, errors, formTouched)
    checkIfEquals(form, errors, formTouched)
    checkIfIsTouched(errors, formTouched)

    if (Object.keys(errors).filter(item => item !== 'isFormValid').length) {
        errors.isFormValid = false
    }
    
    return errors
}